import styled from 'styled-components';
import {
  icon,
  margin,
  padding,
  font,
  animation,
  dimension,
} from '../styleHelper2';

const Icon = styled.i`
  display: inline-block;
  ${icon()}
  ${margin()}
  ${padding()}
  ${font()}
  ${animation()}
  ${dimension()}
`;

export default Icon;
